import React from 'react';
import { Button } from 'antd';
import {
  AppstoreAddOutlined,
  EditOutlined,
  EyeOutlined,
  DeleteOutlined,
  FormOutlined,
  SwapOutlined,
  HistoryOutlined,
} from '@ant-design/icons';
import { typeStyle, deriveEstado } from 'pages/liftlogic/v2/Components/componentTypeStyle';
import { healthStyle } from 'pages/liftlogic/v2/Components/healthStyle';
import 'pages/liftlogic/v2/Components/componentTree.css';

const stop = (fn, node) => (e) => {
  e.stopPropagation();
  fn?.(node);
};

function ComponentTreeRow({
  node,
  typesCatalog,
  canEdit = false,
  matched = false,
  health,
  onAdd,
  onAttrs,
  onRename,
  onDelete,
  onReplace,
  onHistory,
}) {
  const t = typeStyle(node.raw?.node_type ?? null, typesCatalog);
  const Icon = t.Icon;
  const childCount = node.raw?.children?.length || 0;

  // Si viene health (salud real del backend), usarla; si no, fallback a deriveEstado.
  const dotStyle = health ? healthStyle(health.rolled) : deriveEstado(node);

  return (
    <span className={'cmp-row' + (matched ? ' cmp-match' : '')}>
      <span className="cmp-tic" style={{ background: t.tint, color: t.color }}>
        <Icon style={{ fontSize: 15 }} />
      </span>
      <span className="cmp-name">{node.title}</span>
      <span className="cmp-pill" style={{ background: t.tint, color: t.color }}>
        {t.label}
      </span>
      {childCount > 0 && <span className="cmp-count">{childCount}</span>}
      {dotStyle && <span className={'cmp-dot ' + dotStyle.cls} title={dotStyle.label} />}
      {health?.override && (
        <span className="cmp-health-override" title="estado forzado">
          ⚠
        </span>
      )}
      {/* El ack se oculta si hay override vigente (el override manda). */}
      {health?.ack && !health?.override && (
        <span className="cmp-health-ack" title="en seguimiento">
          👁
        </span>
      )}
      <span className="cmp-acts">
        {canEdit && (
          <Button
            size="small"
            type="text"
            icon={<AppstoreAddOutlined />}
            title="Agregar hijo"
            onClick={stop(onAdd, node)}
          />
        )}
        <Button
          size="small"
          type="text"
          icon={canEdit ? <EditOutlined /> : <EyeOutlined />}
          title={canEdit ? 'Atributos' : 'Ver atributos'}
          onClick={stop(onAttrs, node)}
        />
        {canEdit && (
          <Button
            size="small"
            type="text"
            icon={<FormOutlined />}
            title="Renombrar"
            onClick={stop(onRename, node)}
          />
        )}
        {canEdit && (
          <Button
            size="small"
            type="text"
            danger
            icon={<DeleteOutlined />}
            title="Eliminar"
            onClick={stop(onDelete, node)}
          />
        )}
        {onReplace && (
          <Button
            size="small"
            type="text"
            icon={<SwapOutlined />}
            title="Reemplazar"
            onClick={stop(onReplace, node)}
          />
        )}
        {onHistory && (
          <Button
            size="small"
            type="text"
            icon={<HistoryOutlined />}
            title="Historial"
            onClick={stop(onHistory, node)}
          />
        )}
      </span>
    </span>
  );
}

export default ComponentTreeRow;
